import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TARGET_COUNTRY } from './country-target-options';
import { CountryDomainService } from '../../core/country/country-domain.service';

/**
 * Sentinel base URL injected into NSwag-generated admin API clients via their InjectionToken.
 * The interceptor replaces this prefix with the active country domain API origin at request time.
 *
 * Usage in DI providers:
 *   { provide: MONOLITH_ADMIN_API_BASE_URL, useValue: API_BASE_URL_PLACEHOLDER }
 */
export const API_BASE_URL_PLACEHOLDER = '@@api@@';

/**
 * Rewrites requests whose URL starts with API_BASE_URL_PLACEHOLDER to the real
 * country-domain API origin, resolved by CountryDomainService (the single source
 * of truth shared with the SignalR hub URL). Requests tagged with the TARGET_COUNTRY
 * HttpContext token resolve that country's origin instead of the active one.
 */
export const countryDomainBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
    if (!req.url.startsWith(API_BASE_URL_PLACEHOLDER)) {
        return next(req);
    }

    const countryDomainService = inject(CountryDomainService);
    const url = req.url.replace(API_BASE_URL_PLACEHOLDER, countryDomainService.apiBaseUrl(req.context.get(TARGET_COUNTRY) ?? undefined));

    return next(req.clone({ url }));
};
